EASY.utils.toggleMultiSelect = function (select_id, size) {
  var currentEvent = window.event;
  if (typeof currentEvent !== "undefined") {
    $(currentEvent.target).toggleClass("open");
  }
  var select = $("#" + select_id.replace(/(:|\.|\[|\])/g, "\\$1"))[0];
  if (select.multiple === true) {
    select.multiple = false;
    select.size = 1;
  } else {
    select.multiple = true;
    select.size = size || 10;
  }
};

EASY.utils.toggleDiv = function (el_or_id) {
  var el;
  if (typeof el_or_id === "string") {
    el = $("#" + el_or_id);
  } else if (typeof el_or_id === "undefined") {
    return;
  } else {
    el = el_or_id;
  }
  el.slideToggle(0).toggleClass("collapsed");
  $(document).trigger("erui_interface_change_vertical");
  $(document).trigger("erui_interface_change_horizontal");
};

EASY.utils.toggleDivAndChangeOpen = function (toggleElementId, changeOpenElement) {
  EASY.utils.toggleDiv(toggleElementId);
  $(changeOpenElement).toggleClass("open");
};

EASY.utils.setStorageItem = function (root, uniq_id, user_id) {
  const item = { user_id: user_id };

  if (!window.localStorage.getItem(root)) {
    window.localStorage.setItem(root, JSON.stringify({}));
  }

  const localStrg = JSON.parse(window.localStorage.getItem(root));
  const isStorageItem = this.isStorageItem(root, uniq_id);

  isStorageItem ? delete localStrg[uniq_id] : (localStrg[uniq_id] = item);
  window.localStorage.setItem(root, JSON.stringify(localStrg));
};

// Should be used if asyncloadModules will be removed
EASY.utils.loadModules = function () {
  const modules = document.querySelectorAll(".easy-page__module.collapsible");

  modules.forEach(module => {
    EASY.utils.toggleCollapse(module);
  });
};

EASY.utils.toggleCollapse = function (module) {
  if (!module) return;

  // return window.EasyToggler.ensureToggleItem(item);

  const moduleContent = module.querySelector(".module-content");
  const moduleId = moduleContent.id;
  const closed = this.isStorageItem("savedPreferences", moduleId);
  const group = module.querySelector(".group");

  if (closed) {
    !!group && group.classList.remove("open");
    moduleContent.style.display = "none";
    return;
  }
  !!group && group.classList.add("open");
  moduleContent.style.display = "block";
};

EASY.utils.updateUserPref = function (uniq_id, user_id) {
  this.setStorageItem("savedPreferences", uniq_id, user_id);
};

/*
 * ToggleTableRowVisibility('project_index_', 'project', '55', '51');
 */
EASY.utils.toggleTableRowVisibility = function (uniq_prefix, entity_name, entity_id, user_id, update_user_pref) {
  var uniq_id = uniq_prefix + entity_name + "-" + entity_id;
  var tr = $("#" + uniq_id);
  if (update_user_pref) {
    EASY.utils.updateUserPref(uniq_id, user_id, tr.hasClass("open"));
  }
  if (tr.hasClass("open")) {
    EASY.utils.hideTableRow(uniq_prefix, entity_name, entity_id, true);
  } else {
    EASY.utils.showTableRow(uniq_prefix, entity_name, entity_id, false);
  }
  $(document).trigger("erui_interface_change_vertical");
};

EASY.utils.hideTableRow = function (uniq_prefix, entity_name, entity_id, recursive) {
  var tr = $("#" + uniq_prefix + entity_name + "-" + entity_id);
  tr.removeClass("open");
  $("." + uniq_prefix + "parent" + entity_name + "_" + entity_id).each(function () {
    $(this).hide();
    if (recursive && this.id) {
      EASY.utils.hideTableRow(
        uniq_prefix,
        entity_name,
        this.id.substring((uniq_prefix + entity_name + "-").length),
        recursive
      );
    }
  });
  $(document).trigger("erui_interface_change_vertical");
};

EASY.utils.showTableRow = function (uniq_prefix, entity_name, entity_id, recursive) {
  var tr = $("#" + uniq_prefix + entity_name + "-" + entity_id);
  tr.addClass("open");
  $("." + uniq_prefix + "parent" + entity_name + "_" + entity_id).each(function () {
    $(this).show();
    if (recursive && this.id) {
      EASY.utils.showTableRow(
        uniq_prefix,
        entity_name,
        this.id.substring((uniq_prefix + entity_name + "-").length),
        uniq_prefix,
        recursive
      );
    }
  });
  $(document).trigger("erui_interface_change_vertical");
};

EASY.utils.toggleMyPageModule = function (expander, element, user, ajaxUpdateUserPref) {
  var group = $(expander).parent("div");
  var isOpened = group.hasClass("open");
  const activityFeedSelector = ".easy-activity-feed__activity-event-wrapper";

  const isModuleActivityFeed = () => {
    const module = document.getElementById(element);
    return module && !!module.querySelector(activityFeedSelector);
  };

  group.toggleClass("open");

  if (ajaxUpdateUserPref) {
    EASY.utils.updateUserPref(element, user, isOpened);
  }
  var $module = $("#" + element);
  $module.fadeToggle(function () {
    $(document).trigger("erui_interface_change_vertical", [isOpened, element]);
  });
  affix.recalculateHeads(ERUI.tableHeads);
  EASY.responsivizer.fakeResponsive();
  $module.find(".thumbnails").each(function (index) {
    EASY.utils.initGalereya($(this));
  });
  $module.trigger("easy-module-collapse-changed", [isOpened]);

  if (!isModuleActivityFeed()) return;
  setTimeout(() => {
    new ActivityTimeline(activityFeedSelector);
  }, 0);
};

EASY.utils.openTogglingContainer = function (expander, element) {
  var group = $(expander).parent("div");
  group.addClass("open");
  $("#" + element).fadeIn();
  EASY.responsivizer.fakeResponsive();
  $(document).trigger("erui_interface_change_vertical");
};

/**
 * almighty implementation for dealing with timezones 'automagically'
 * @param {string} dateArg in ISO 8601 format, optionally with the time and timezone. Fullest version is 'YYYY-MM-DD hh:mm:ss.mmmZ', for example '2021-03-02 15:04:45.133+01'
 * @return {Date} object with shifted value - including users local offset (browser) and users preferred timezone (settings)
 */
EASY.utils.parseDate = dateArg => {
  /*
  there are multiple problems we have to deal with:
  A) backend sends date(time) values in different formats (without time (~ utc), with time but without timezone (~ utc) or with time & specific timezone)
  B) javascript date object always displays in local timezone (eg timezone set by the location of the browser, see:
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset or
  https://dev.to/zachgoll/a-complete-guide-to-javascript-dates-and-why-your-date-is-off-by-1-day-fi1
  C) user can have different timezone set in the ER/EP, than his browser/workstation has
  D) browser specific stuff - Safari wont parse RFC 822 time zone format

  therefore the logic is as:
  1) decide about format
  2) normalize it and convert to desired timezone
  3) parse into javascript Date
  */
  if (dateArg == null) {
    console.warn("EASY.utils.parseDate wants string as a parameter, but got null");
    return null;
  }

  // this method is supposed to be called from everywhere, so deal with those places, which sends actual Date object
  const skipParsing = dateArg instanceof Date;
  if (skipParsing) {
    console.warn("EASY.utils.parseDate wants string as a parameter, but got Date", dateArg);
  } else {
    const dateHash = dateArg.match(
      /^([0-9]{4})(-([0-9]{2})(-([0-9]{2})([T ]([0-9]{2}):([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?(Z|(([-+])([0-9]{2})(:?([0-9]{2}))?))?)?)?)?$/
    );
    if (!dateHash) {
      console.warn("EASY.utils.parseDate wants date in iso 8601 format, but got", dateArg);
      return null;
    }

    const time = dateHash[6];
    // no time means no timezone, return as-is
    if (!time) return new Date(dateArg);
  }
  const timezone = EASY.currentUser.time_zone_identifier || "UTC";

  // https://momentjs.com/guides/#/parsing/local-utc-zone/
  const normalizedDate = moment.utc(dateArg);
  // to user's timezone and as string, to avoid local offset (eq timezone suffix)
  const formattedDate = normalizedDate.tz(timezone).format("YYYY-MM-DD HH:mm:ss.SSS");
  // wrap the date in the Moment to avoid cross-browser inconsistencies https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date#Timestamp_string
  const correctDate = new Date(moment(formattedDate));
  return correctDate;
};

EASY.utils.submitForm = function (form_id, url) {
  var frm = $("#" + form_id);
  frm.attr("action", url);
  frm.submit();
};

/**
 *
 * @param {String} url
 * @param {String} filename
 */
EASY.utils.downloadRemoteDataAsFile = function (url, filename, failMessage) {
  $.ajax({
    url: url,
    dataType: "text",
    success: function (data) {
      EASY.utils.downloadDataAsFile(data, filename);
    },
    error: function () {
      showFlashMessage("error", failMessage, 1500);
    },
  });
};

/**
 *
 * @param {String} data
 * @param {String} filename
 */
EASY.utils.downloadDataAsFile = function (data, filename) {
  var type = "text/plain";

  var element = document.createElement("a");
  element.setAttribute("download", filename);
  element.setAttribute("type", type);

  var dataBlob = new Blob([data]);
  element.href = URL.createObjectURL(dataBlob);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

(function () {
  /**
   *
   * @param {String} field
   * @param {Array.<int>} indexes
   * @param {String} modul_uniq_id
   */
  function enableValues(field, indexes, modul_uniq_id) {
    var div_values = $("#" + modul_uniq_id + "div_values_" + field);
    div_values.toggle(indexes.length > 0);
  }

  /**
   *
   * @param {String} field
   * @param {String} modul_uniq_id
   */
  EASY.utils.toggleOperator = function (field, modul_uniq_id) {
    var operator = $("#" + modul_uniq_id + "operators_" + field);
    if (typeof operator.val() === "undefined") {
      $("#" + modul_uniq_id + "div_values_" + field).show();
    } else {
      switch (operator.val()) {
        case "!*":
        case "*":
        case "t":
        case "ld":
        case "w":
        case "lw":
        case "l2w":
        case "m":
        case "lm":
        case "y":
        case "o":
        case ">dd":
        case "c":
          enableValues(field, [], modul_uniq_id);
          break;
        case "*o":
        case "!o":
          enableValues(field, [], modul_uniq_id);
          break;
        case "><":
          enableValues(field, [0, 1], modul_uniq_id);
          break;
        case "<t+":
        case ">t+":
        case "><t+":
        case "t+":
        case ">t-":
        case "<t-":
        case "><t-":
        case "t-":
          enableValues(field, [2], modul_uniq_id);
          break;
        case "=p":
        case "=!p":
        case "!p":
          enableValues(field, [1], modul_uniq_id);
          break;
        default:
          enableValues(field, [0], modul_uniq_id);
          break;
      }
    }
  };
})();

// Function for updating textareas to content from CKEDITOR
EASY.utils.updateCKE = function () {
  if (!(typeof CKEDITOR === "undefined")) {
    var instance;
    for (instance in CKEDITOR.instances) {
      CKEDITOR.instances[instance].updateSourceElement();
    }
  }
};

// Function for updating form and sendind data also from CKEDITOR
//
// e.g. onchange status, tracker, ...
EASY.utils.updateForm = function (form, url) {
  EASY.utils.updateCKE();

  $.ajax({
    url: url,
    type: "post",
    data: $(form).serialize(),
  });
};

EASY.utils.submitModalForm = function (modalElement, appendContinue) {
  EASY.utils.updateCKE();
  var frm = $(modalElement).find("form:first");
  if (appendContinue) {
    frm.append('<input type="hidden" value="1" name="continue" />');
  }
  frm.submit();
};

EASY.utils.goToUrl = function (url, e) {
  var target = e.target || e.srcElement;
  if (
    target &&
    (target.nodeName === "INPUT" || target.nodeName === "A" || $(target).parents().hasClass("easy-autocomplete-tag"))
  ) {
    return false;
  }
  if (e !== null && e !== "undefined") {
    if (!e.ctrlKey && !e.shiftKey && !e.metaKey) {
      window.location = url;
    } else {
      // do nothing
    }
  } else {
    window.location = url;
  }
  return true;
};

EASY.utils.showAndScrollTo = function (element_id, offsetDelta, container_id) {
  if (!offsetDelta) {
    offsetDelta = 0;
  }
  var $container;
  var $el = $("#" + element_id);
  if (container_id) {
    $container = $("#" + container_id);
  } else {
    $container = $el;
  }
  $el.show();
  $("html, body").animate(
    {
      scrollTop: $container.offset()?.top + offsetDelta,
    },
    500
  );
  $(document).trigger("erui_interface_change_vertical");
};

EASY.utils.displayTabsButtons = function (css_selector) {
  $(css_selector).each(function () {
    let tabsWidth = 0;
    const lis = $(this).find("ul").children("li");
    lis.each(function (index, li) {
      const liEl = $(li);
      if (liEl.is(":visible")) {
        tabsWidth += liEl.outerWidth();
      }
    });
    const $buttons = $(this).find("div.tabs-buttons, td.tabs-button");
    const shouldShowButtons = !(tabsWidth < $(this).width() - 120 && lis.first().is(":visible"));
    $(this).toggleClass("tabs--buttons-visible", shouldShowButtons);
    $buttons.toggleClass("tabs-buttons--visible", shouldShowButtons);
    $buttons.toggle(shouldShowButtons);
  });
};

EASY.utils.moveTabRight = function (el) {
  var lis = $(el).parents("div.tabs").first().find("ul").children();
  var tabsWidth = 0;
  var i = 0;
  var that;
  lis.each(function () {
    that = $(this);
    if (that.is(":visible")) {
      tabsWidth += that.outerWidth();
    }
  });
  if (tabsWidth < $(el).parents("div.tabs").first().width() - 120) {
    return;
  }
  while (i < lis.length && !lis.eq(i).is(":visible")) {
    i++;
  }
  const width = lis.eq(i).width();
  lis.eq(i).hide();
  $(el).siblings(".tab-left").removeClass("disabled");
  if (tabsWidth - width < $(el).parents("div.tabs").first().width() - 120) {
    $(el).addClass("disabled");
  }
};

EASY.utils.moveTabLeft = function (el) {
  var lis = $(el).parents("div.tabs").first().find("ul").children();
  var i = 0;
  while (i < lis.length && !lis.eq(i).is(":visible")) {
    i++;
  }
  if (i > 0) {
    lis.eq(i - 1).show();
    $(el).siblings(".tab-right").removeClass("disabled");
  }
  if (i <= 1) {
    $(el).addClass("disabled");
  }
};

/**
 *
 * @param {jQuery} $from_el
 * @param {jQuery} $to_el
 */
EASY.utils.switchElements = function ($from_el, $to_el) {
  $from_el.hide();
  $to_el.show();
};

EASY.utils.toggleCheckbox = function (id) {
  var el = $("#" + id);
  if (el) {
    el.prop("checked", !el.is(":checked"));
  }
};

EASY.utils.toggleSidebar = function () {
  ERUI.body.toggleClass("nosidebar");
  ERUI.document.trigger("easySidebarToggled");
  // ERUI.main.trigger($.Event('resize'));
  EASY.utils.updateUserPref("open_sidebar", null, ERUI.body.hasClass("nosidebar"));
  EASY.responsivizer.fakeResponsive();
};

(function () {
  function showImportantJournalDetails(journal) {
    journal.find(".journal-details-container ul.details > li").each(function () {
      var self = $(this);
      self.toggle(self.hasClass("important"));
    });
  }

  EASY.journals.collapseUnnecessary = function () {
    var $toggler = $(".journal-details-toggler");
    var journals_to_hide = $toggler.closest(".journal").toArray();
    if ($(journals_to_hide).last()[0] === $(".journal.has-details:last-child").last()[0]) {
      $(journals_to_hide.pop()).find(".expander").parent().toggleClass("open"); // all except last
    }
    $(journals_to_hide).each(function (index, i) {
      var journal = $(i);
      journal.find(".avatar-container img").toggleClass("smallest-avatar");
      showImportantJournalDetails(journal);
    });
    $toggler.click(function (event) {
      var expander = $(event.target);
      EASY.journals.toggleDetails(expander.closest(".journal"));
    });
  };
  EASY.journals.toggleDetails = function (journal) {
    journal.find(".avatar-container img").toggleClass("smallest-avatar");
    journal.find(".journal-details-container ul.details > li:not(.important)").each(function () {
      $(this).toggle();
    });
    journal.find(".expander").parent().toggleClass("open");
  };
})();

EASY.modalSelector.showModal = function (width) {
  showModal("ajax-modal", width || "70%");
};

EASY.contextMenu.reloadInit = function () {
  if (EASY.contextMenu.initializers) {
    $.each(EASY.contextMenu.initializers, function (index, fce) {
      eval(fce);
    });
  }
};

EASY.utils.delayedRAF = function (callback, delay) {
  return setTimeout(function () {
    window.requestAnimationFrame(callback);
  }, delay);
};

EASY.utils.backToTop = function () {
  $("html, body").animate(
    {
      scrollTop: 0,
    },
    200
  );
};

EASY.utils.contentHeightSwitchable = function (class_name, label_more, label_less) {
  var wikiSelector = ".wiki";
  var contentSelector = "." + class_name,
    buttonFull = $("<a />").text(label_more).addClass("switchFull"),
    buttonLess = $("<a />").text(label_less).addClass("switchLess");

  $(wikiSelector + " > " + contentSelector).each(function () {
    var block = $(this);

    if (block[0].scrollHeight > block[0].offsetHeight) {
      block.after(buttonFull.clone());
    }
  });

  ERUI.document.on("click", ".switchFull", function () {
    var switchFullLink = $(this);
    switchFullLink.prev(contentSelector).removeClass(class_name);
    switchFullLink.replaceWith(buttonLess.clone());
  });

  ERUI.document.on("click", ".switchLess", function () {
    var switchLessLink = $(this);
    switchLessLink.prev("div").addClass(class_name);
    switchLessLink.replaceWith(buttonFull.clone());
  });
};

EASY.utils.setNameToModuleHead = function (input) {
  var textFromInput;
  if (input.tagName === "SELECT") {
    textFromInput = $("option:selected", input).text();
  } else {
    textFromInput = input.value;
  }
  $(input).closest("div.easy-page-module.box").find(".module-heading-title").text(textFromInput);
};

EASY.utils.setInfiniteScrollDefaults = function () {
  $.extend($.infinitescroll.defaults, {
    behavior: "easy",
    previousSelect: null,
  });
  $.infinitescroll.prototype._nearbottom_easy = function () {
    var documentHeight = $(document).height();
    var opts = this.options;
    var pixelsFromWindowBottomToBottom = documentHeight - opts.binder.scrollTop() - $(window).height();
    var cnt = $(opts.contentSelector);
    var navToBottom = documentHeight - cnt.position().top - cnt.height();
    return pixelsFromWindowBottomToBottom < navToBottom + opts.bufferPx;
  };
  $.infinitescroll.prototype._setup_easy = function () {
    this._binding("bind");
    if (this.options.previousSelect === null || $(this.options.previousSelect).length === 0) {
      $(".infinite-scroll-load-next-page-trigger").parent().show();
    }
    return false;
  };
  $.extend($.infinitescroll.defaults.loading, {
    selector: "#main .infinite-scroll-load-next-page-trigger-container",
    msgText: "",
    localMode: true,
    finishedMsg: "",
    debug: true,
  });
};

EASY.utils.initProjectEdit = function () {
  /*
   * Project inline editing with autocomplete.
   */
  $(".project-autocomplete-edit")
    .not(".initialized")
    .on("click", function (evt) {
      // The pencil is `<a href="#">`; the fragment navigation would tear Intercom down. Refs #694109.
      evt.preventDefault();
      evt.stopPropagation();
      var target = $(evt.currentTarget);
      const projectSelect = target.siblings(".easy-autocomplete-tag").children('input[type="search"]');

      target.siblings(".editable").toggle();
      target.siblings(".easy-autocomplete-tag").toggle();

      if (projectSelect) projectSelect.select();
    })
    .addClass("initialized");
};

EASY.utils.initFileUploads = function () {
  EASY.schedule.late(function () {
    if (typeof cbImagePaste !== "undefined" && typeof cbImagePaste.adjustCbpImageParts === "function") {
      cbImagePaste.adjustCbpImageParts();
    }
  });
  return true;
};

(function () {
  function closeBroadcast(broadcastId) {
    $.ajax({
      type: "POST",
      url: window.urlPrefix + "/easy_broadcasts/mark_as_read.json",
      noLoader: true,
      data: { id: broadcastId },
    });
  }

  EASY.utils.broadcast.showBroadcastFlashMessage = function (type, message, broadcastId) {
    return $("<div/>")
      .attr({ class: "flash notice" })
      .addClass(type)
      .html($("<span/>").html(message))
      .append(
        $("<a/>")
          .attr({ href: "javascript:void(0)", class: "icon icon-close" })
          .click(function () {
            closeBroadcast(broadcastId);
            $(this)
              .closest(".flash")
              .fadeOut(500, function () {
                $(this).remove();
              });
          })
      )
      .prependTo($("#content"));
  };
})();

class Fullscreen {
  constructor(contentSelector, triggerButtonSelector) {
    this.content = contentSelector;
    this.triggerButton = triggerButtonSelector;
  }

  init() {
    if (!this.content || !this.triggerButton) return;
    this.triggerButton.addEventListener("click", this.setUnsetFullScreen.bind(this));
    this.addFullscreenChangeEventListener();
  }

  addFullscreenChangeEventListener() {
    document.addEventListener("fullscreenchange", this.onFullscreenChanged.bind(this));
    document.addEventListener("webkitfullscreenchange", this.onFullscreenChanged.bind(this));
    document.addEventListener("mozfullscreenchange", this.onFullscreenChanged.bind(this));
    document.addEventListener("MSFullscreenChange", this.onFullscreenChanged.bind(this));
  }

  getFullscreenElement() {
    return (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );
  }

  onFullscreenChanged() {
    const fullscreenElement = this.getFullscreenElement();

    if (!fullscreenElement) {
      this.triggerButton.classList.remove("fullscreen__trigger_active");
      this.content.classList.remove("fullscreen");
      document.body.classList.remove("fullscreen--active");
    } else {
      this.triggerButton.classList.add("fullscreen__trigger_active");
      this.content.classList.add("fullscreen");
      document.body.classList.add("fullscreen--active");
    }
  }

  setUnsetFullScreen() {
    const fullscreenElement = this.getFullscreenElement();

    if (!fullscreenElement) {
      if (!this.triggerButton) return;
      this.openBrowserFullscreen();
      // utm-inventory-description: Enters fullscreen from the service bar fullscreen control.
      $.ajax({ url: `?utm_campaign=fullscreen&utm_content=service_bar&utm_term=on` }); // just to send UTM parameter to server
    } else {
      if (!this.triggerButton) return;
      // utm-inventory-description: Exits fullscreen from the service bar fullscreen control.
      $.ajax({ url: `?utm_campaign=fullscreen&utm_content=service_bar&utm_term=off` }); // just to send UTM parameter to server
      this.closeBrowserFullscreen();
    }
  }

  setFullScreenOnly() {
    this.content.classList.add("fullscreen");
  }

  openBrowserFullscreen() {
    const html = document.documentElement;
    if (html.requestFullscreen) {
      html.requestFullscreen();
    } else if (html.mozRequestFullScreen) {
      /* Firefox */
      html.mozRequestFullScreen();
    } else if (html.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      html.webkitRequestFullscreen();
    } else if (html.msRequestFullscreen) {
      /* IE/Edge */
      html.msRequestFullscreen();
    }
  }

  closeBrowserFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE/Edge */
      document.msExitFullscreen();
    }
  }
}

EASY.utils.FullScreen = Fullscreen;

EASY.utils.EasyChartsOnInit = function () {
  function _chartOnInit(self) {
    self.api.resize();
  }

  var self = this;

  if (window.matchMedia) {
    window.matchMedia("print").addListener(function (media) {
      _chartOnInit(self);
    });
  } else {
    // basically a fallback for < IE11
    window.addEventListener("beforeprint", _chartOnInit(self), false);
  }
};

EASY.utils.shiftStartEndTime = ({ endTimeEl, endDateEl, startTimeEl, startDateEl }) => {
  const DATE_FORMAT = "YYYY-MM-DD";
  const TIME_FORMAT = "HH:mm";

  let prevStartDateVal = moment(`${startDateEl.value} ${startTimeEl.value}`);

  const shiftDateTime = () => {
    if (!startTimeEl || !endTimeEl || !startDateEl || !endDateEl) return;
    const startDateTime = moment(`${startDateEl.value} ${startTimeEl.value}`);
    const endDateTime = moment(`${startDateEl.value} ${endTimeEl.value}`);
    if (!startDateTime.isValid || !endDateTime.isValid) return;
    const shift = moment.duration(startDateTime.diff(prevStartDateVal)).asMinutes();
    const shiftedEndDateTime = moment(endDateTime).add(shift, "minutes");
    endDateEl.value = startDateTime.format(DATE_FORMAT);
    endTimeEl.value = shiftedEndDateTime.format(TIME_FORMAT);
    prevStartDateVal = startDateTime;
  };
  startTimeEl.addEventListener("change", shiftDateTime);
  // because of datepicker it has to be jquery,
  // vanilla "change" event is not triggered on date change from picker
  $(startDateEl).on("change", shiftDateTime);
};

EASY.utils.toggleMenu = function (noUserPref = false) {
  ERUI.topMenu.toggleClass("collapsed");
  ERUI.body.toggleClass("top_menu--collapsed");
  ERUI.main.trigger($.Event("easySidebarToggled"));
  if (!noUserPref) EASY.utils.updateUserPref("hide_menu", null, ERUI.topMenu.hasClass("collapsed"));
  window.easyView.sticky.rebuild();
};

EASY.utils.debounce = (id, callback, timeout = 500) => {
  if (!window.EasyDebounceTimers) {
    window.EasyDebounceTimers = {};
  }
  clearTimeout(window.EasyDebounceTimers[id]);
  window.EasyDebounceTimers[id] = setTimeout(() => {
    callback();
  }, timeout);
};

EASY.utils.roundPercentageOnInput = (numberInput, id, setValueCallback, options = {}) => {
  EASY.utils.debounce(id, () => {
    const inputValue = numberInput.value;
    const roundedValue = EASY.utils.getRoundedPercentageValue(inputValue, options);

    numberInput.value = roundedValue;
    $(numberInput).trigger("input");
    setValueCallback(inputValue);
  });
};

EASY.utils.getRoundedPercentageValue = (inputValue, options) => {
  const { min = 0, max = 100, step = 10 } = options;
  const parsedValue = isNaN(parseInt(inputValue)) ? 0 : parseInt(inputValue);
  let roundedValue = Math.round(parsedValue / step) * step;

  if (roundedValue < min) {
    roundedValue = min;
  }

  if (roundedValue > max) {
    roundedValue = max;
  }

  return roundedValue;
};

/**
 * @param {string} remValue
 * @return {number}
 */
EASY.utils.convertRemToPx = function (remValue) {
  const remNumber = parseFloat(remValue);
  return remNumber * parseFloat(getComputedStyle(document.documentElement).fontSize);
};

/**
 * Expand menu if collapsed, not saved state in local storage.
 */
EASY.utils.expandMenuNoUserPref = function () {
  if (ERUI.topMenu.hasClass("collapsed")) EASY.utils.toggleMenu(true);
};
